export const AccountStatementData = [
  {
    id:'1',
    Reference_Number: "#AS842",
    Date: "24 Dec 2024",
    Category: "Sale",
    Description: "Sale of goods",
    Amount: "+$200",
    Transaction_Type: "Credit",
    Balance: "$4365",
  },
  {
    id:'2',
    Reference_Number: "#AS821",
    Date: "10 Dec 2024",
    Category: "Refund",
    Description: "Refund Issued",
    Amount: "-$50",
    Transaction_Type: "Debit",
    Balance: "$4444",
  },
  {
    id:'3',
    Reference_Number: "#AS847",
    Date: "27 Nov 2024",
    Category: "Purchase",
    Description: "Inventory restocking",
    Amount: "-$800",
    Transaction_Type: "Debit",
    Balance: "$65145",
  },
  {
    id:'4',
    Reference_Number: "#AS874",
    Date: "18 Nov 2024",
    Category: "Sale",
    Description: "Sale of goods",
    Amount: "+$100",
    Transaction_Type: "Credit",
    Balance: "$1848",
  },
  {
    id:'5',
    Reference_Number: "#AS887",
    Date: "06 Nov 2024",
    Category: "Purchase",
    Description: "Inventory restocking",
    Amount: "-$700",
    Transaction_Type: "Debit",
    Balance: "$986",
  },
  {
    id:'6',
    Reference_Number: "#AS856",
    Date: "25 Oct 2024",
    Category: "Utility Payment",
    Description: "Electricity Bill",
    Amount: "-$1000",
    Transaction_Type: "Debit",
    Balance: "$15547",
  },
  {
    id:'7',
    Reference_Number: "#AS822",
    Date: "14 Oct 2024",
    Category: "Equipment Purchase",
    Description: "New POS terminal purchased",
    Amount: "-$1200",
    Transaction_Type: "Debit",
    Balance: "$141645",
  },
  {
    id:'8',
    Reference_Number: "#AS844",
    Date: "03 Oct 2024",
    Category: "Refund",
    Description: "Refund Issued",
    Amount: "-$750",
    Transaction_Type: "Debit",
    Balance: "$4356",
  },
  {
    id:'9',
    Reference_Number: "#AS832",
    Date: "20 Sep 2024",
    Category: "Withdraw",
    Description: "Withdraw by accountant",
    Amount: "-$450",
    Transaction_Type: "Debit",
    Balance: "614389",
  },
 
];
